import { BookedGuestSurveyDisplayStatus, type HotelDisplaySettingsInput } from "@/lib/gql/__generated__/graphql";

import type { AccommodationHotelPolicyFormModel } from "../../../type";

type Props = {
	viewModel: AccommodationHotelPolicyFormModel["ViewModel"];
	hotelDisplaySettingsId: string;
	hotelID: string;
};

export const viewModelToHotelDisplaySettingsInputConverter = ({
	viewModel,
	hotelDisplaySettingsId,
	hotelID,
}: Props): HotelDisplaySettingsInput => {
	return {
		id: hotelDisplaySettingsId,
		hotelID,
		isShowCheckInOutTime: viewModel.isShowCheckInOutTime.value,
		bookedGuestSurveyDisplayStatus:
			viewModel.bookedGuestSurveyDisplayStatus?.value ?? BookedGuestSurveyDisplayStatus.Unset,
	};
};
